import { useLocation } from 'react-router'

import useFeatureFlag from 'hooks/useFeatureFlag'

import SimpleLink from '../../display/SimpleLink'
import Banner from '../Banner'

export const VoucherBannerComponent = () => {
  return (
    <Banner>
      Looking for the perfect gift?{' '}
      <SimpleLink textDecoration="underline" to="/vouchers?ref=voucher_banner">
        Buy a Riparide Voucher
      </SimpleLink>
    </Banner>
  )
}

const displayOnRoutes = ['/', '/vic', '/nsw', '/nz']
const displayOnRouteFragments = ['/stories/', '/listings/']

export default () => {
  const { pathname } = useLocation()

  const hasFeatureFlag = useFeatureFlag('voucher_banner')

  const matchingRoutes = displayOnRoutes.filter((path) => path === pathname)

  const matchingRouteFragments = displayOnRouteFragments.filter((fragment) =>
    pathname.includes(fragment)
  )

  const display = matchingRoutes.length > 0 || matchingRouteFragments.length > 0

  if (hasFeatureFlag && display) {
    return <VoucherBannerComponent />
  }

  return null
}
